import { render, staticRenderFns } from "./singleStubMatch.vue?vue&type=template&id=3cbe15ab&scoped=true&"
import script from "./singleStubMatch.vue?vue&type=script&lang=js&"
export * from "./singleStubMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbe15ab",
  null
  
)

export default component.exports